import type {
  ReservationListItem,
  TicketReservationByPnrData,
} from '../../../services/reservationsApi';

export const RESERVATION_STATUS_COLOR_MAP: Record<
  string,
  'success' | 'error' | 'warning' | 'primary' | 'default'
> = {
  Approved: 'success',
  Rejected: 'error',
  Cancelled: 'error',
  Pending: 'warning',
  Consumed: 'primary',
};

export const formatReservationDate = (value?: string): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('tr-TR');
};

export const formatReservationDateTime = (value?: string): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('tr-TR');
};

export const formatReservationCurrency = (value?: number): string =>
  `${Number(value || 0).toLocaleString('tr-TR')} TL`;

export const buildRowNumberMap = (rows: ReservationListItem[]): Record<number, number> => {
  const map: Record<number, number> = {};
  rows.forEach((row, index) => {
    map[row.id] = index + 1;
  });
  return map;
};

export const mapRowToTicketDetailFallback = (
  row: ReservationListItem,
  pnrCode: string
): TicketReservationByPnrData | null => {
  if (!row.ticketDetail) return null;

  return {
    reservationId: row.reservationId,
    pnrCode,
    reservationDate: row.ticketDetail.reservationDate || row.reservationDate,
    guestCount: row.ticketDetail.guests?.length || 0,
    totalAmount: Number(row.ticketDetail.totalAmount || row.totalAmount || 0),
    authorizedPerson: row.ticketDetail.authorizedPerson,
    guests: row.ticketDetail.guests || [],
    lineItems: row.ticketDetail.lineItems || [],
  };
};

export const mapReservationStatusToCalendar = (
  status: ReservationListItem['status']
): 'approved' | 'rejected' | 'pending' | 'consumed' => {
  if (status === 'Approved') return 'approved';
  if (status === 'Rejected' || status === 'Cancelled') return 'rejected';
  if (status === 'Consumed') return 'consumed';
  return 'pending';
};
